import { useMessageInstanceEvent as usePlatformMessageInstanceEvent } from '@atlassian/message-instance-event-frontend-client/useMessageInstanceEvent';
import type { MessageInstanceEventHookScope } from '@atlassian/message-instance-event-frontend-client/useMessageInstanceEvent';

export type { MessageInstanceEventHookScope } from '@atlassian/message-instance-event-frontend-client/useMessageInstanceEvent';
export type { MessageInstanceClickedParams } from '@atlassian/message-instance-event-frontend-client/types';

export const useMessageInstanceEvent: () => MessageInstanceEventHookScope =
	usePlatformMessageInstanceEvent;
